<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    :persistent="true"
    class="dialog-send"
  >
    <v-card>
      <v-btn icon dark @click="close">
        <v-icon color="primary">close</v-icon>
      </v-btn>
      <v-form ref="form" lazy-validation class="px-4" v-if="dialog">
        <v-text-field
          :rules="phoneRule"
          v-model="phones"
          class="ma-0"
          placeholder="Số điện thoại"
          required
          validate-on-blur
        ></v-text-field>
        <v-textarea
          :rules="mesRule"
          v-model="smsContent"
          class="ma-0"
          placeholder="Nội dung tin nhắn"
          required
          validate-on-blur
        ></v-textarea>
        <p class="caption text-xs-right" :class="smsContent && smsContent.length > 160 ? 'orange--text text--darken-2' : ''">({{smsContent && smsContent.length || 0}} ký tự)</p>
      </v-form>
      <div class="text-xs-right">
        <v-menu
          top
          :offset-y="true"
          class="d-inline"
        >
          <template v-slot:activator="{ on }">
            <v-btn color="primary" v-on="on" large style="padding:0 30px">
              SMS mẫu &nbsp;
              <v-icon>textsms</v-icon>
            </v-btn>
          </template>
          <v-card class="mx-auto" max-width="344px" outlined tile>
            <VuePerfectScrollbar class="sms-menu">
              <v-list max-width="334px" two-line>
                <template v-for="(item,index) in patterns" :data-index="index">
                  <v-list-tile :key="index" @click="activePattern(item)" :data-index="index">
                    <v-list-tile-content :data-index="index">
                      <v-list-tile-title :data-index="index" v-text="item.Title"></v-list-tile-title>
                      <v-list-tile-sub-title :data-index="index" v-text="item.Content"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </VuePerfectScrollbar>
            <v-divider></v-divider>
            <v-btn color="primary" @click="openNewSms()">Thêm mới</v-btn>
          </v-card>
        </v-menu>
        <v-btn
          class="ma-2"
          tile
          outlined
          color="success"
          @click="sendSms"
          large
          style="padding:0 30px"
        >
          Gửi
          <v-progress-circular indeterminate size="22" v-if="loading" class="ml-3"></v-progress-circular>
          <v-icon right v-else>send</v-icon>
        </v-btn>
      </div>
    </v-card>
    <add-new-sms ref="dialogNewSms" @loadSms="handleLoadSms"/>
  </v-dialog>
</template>

<script>
import AddNewSms from './AddNewSms';
import { mapActions, mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    AddNewSms,
    VuePerfectScrollbar
  },
  props: {

  },
  data () {
    return {
      dialog: false,
      phones: '',
      smsContent: '',
      mesRule: [value => !!value || 'Nội dung tin nhắn không được để trống'],
      dialogNewSms: false,
      patterns: [
      ],
      phoneRule:
      [
        value => !!value || 'Số điện thoại không được để trống',
        value => value.length >= 10 || 'Số điện thoại phải có ít nhất 10 kí tự',
        value => /^[0-9,]+$/.test(value) || 'Chỉ được nhập số và dấu phẩy'
      ],
      titleSms: '',
      contentSms: '',
      list: [],
      smsLength: 0,
      loading: false
    };
  },
  computed: {
    ...mapGetters(['loggedUser'])
  },
  watch: {
  },
  async mounted () {
    let resAvailableSms = await this.GetAvailableMessage();
    this.patterns = resAvailableSms;
  },
  methods: {
    ...mapActions(['GetAvailableMessage', 'DeleteAvailableMessage', 'SendSMS']),
    close () {
      this.dialog = false;
    },
    open (data) {
      this.reset();
      if (data) {
        this.phones = data.account.PrimaryContactPhone;
        this.list = data.list;
        console.log('data', data);
      }
      this.dialog = true;
    },
    async sendSms () {
      if (this.phones && this.smsContent) {
        this.loading = true;
        const Content = this.smsContent;
        const phoneList = this.phones.split(',');
        const Email = this.loggedUser.Email;
        let data = {
          Phone: phoneList,
          Content: Content,
          Email: Email
        };
        let success = false;
        let result = await this.SendSMS(data).catch(() => {
          success = false;
        });
        if (result) { success = true }
        this.loading = false;
        this.$emit('success', success);
        this.close();
      }
      else {
        this.$refs.form.validate();
      }
    },
    openNewSms (data) {
      this.$refs.dialogNewSms.open(data);
    },
    activePattern (data) {
      let plates = null;
      this.smsContent = data.Content;
      if (this.list.length) {
        plates = this.list.map(item => item.Plate).join(', ');
        this.smsContent = this.smsContent.replace('(plate)', ' ' + plates);
      }
    },
    reset () {
      this.phones = '';
      this.smsContent = '';
      this.list = [];
      this.list = false;
    },
    handleLoadSms (value) {
      this.patterns = value;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/sms/DialogSendSms.vue